import { environment } from '../../../environments/environment';

const googleMapsApiKey = {
    "success": true,
    "message": "Google Maps configuration retrieved successfully",
    "data": {
        "libraries": environment.googleMaps.libraries,
        "restrictions": environment.googleMaps.restrictions,
        "language": environment.googleMaps.language,
        "apiKey": environment.googleMaps.apiKey,
        "region": environment.googleMaps.region,
    },
    "timestamp": "2026-02-09T15:27:14.649Z"
};
export default googleMapsApiKey;